import{i as initialize}from"./ionic-global-ddef3a45.js";var globalScripts=initialize;export{globalScripts as g};